module.exports = __webpack_public_path__ + "static/media/roger.e7bc178b.jpeg";